import { defineComponent } from 'vue';
import { shortkeyStatusbar } from '@/mixins/common/shortkeyStatusbar';
import { mixinSuper } from '@/mixins/common/mixinSuper';
import { ModuleLayout, ModuleContext, ModuleDbOption } from '@/stores/moduleConst';
import { mapState, mapActions, mapGetters } from 'vuex';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import IndexedDB from '@/commons/indexedDB';
import { printVoucher } from '@/mixins/common/printVoucher';
import { permission } from '@/mixins/common/permission';
import { collectionMonitor } from '@/setup/utilities/monitor';
import _ from 'lodash';
import api from '@/apis/report/voucherReportPrintAPI';

export default defineComponent({
  name: 'BaseVoucherReportParam',
  mixins: [printVoucher, shortkeyStatusbar, mixinSuper, permission],
  data() {
    return {
      /**
       * Mã màn hình hiện tại
       */
      screenCode: '',

      /**
       * Model lưu trữ param
       */
      model: {},

      /**
       * refname control hiển thị dữ liệu: grid/tree
       */
      viewRef: 'viewList',

      /**
       * Các thông tin cấu hình trên grid
       *
       */
      gridInfo: {
        selected: [],
        /**
         * Số lượng bản ghi trên 1 trang
         */
        pageSize: 20,
      },

      /**
       * Tách riêng request lấy summary ra khỏi hàm lấy paging data
       */ splitLoadRequest: true,
      /**
       * Lưu thông tin của chứng từ đã in
       * tbngoc 21.02.2023
       */
      reportConfigPrints: [],
    };
  },
  computed: {
    /**
     * Đối tượng hiển thị grid/view
     */
    grid() {
      return this.$refs[this.viewRef];
    },
    /**
     * Chọn nhiều bản ghi
     */
    multiSelected() {
      return this.gridInfo.selected?.length > 1;
    },
    ...mapGetters({
      /**
       * Ngôn ngữ hiện tại
       */
      Culture: ModuleContext + '/Culture',
      postedDate: ModuleContext + '/PostedDate',
    }),
    ...mapGetters(ModuleContext, ['Context']),
    /**
     * Đối tượng state của store
     */
    storeState() {
      return this.$store.state[this.module];
    },
    /**
     * Dữ liệu hiển thị
     */
    empty() {
      return this.storeState.empty;
    },
    /**
     * Dữ liệu hiển thị
     */
    items() {
      return this.storeState.items;
    },
    /**
     * loading
     */
    loading() {
      return this.storeState.loading;
    },
    /**
     * Tổng số
     */
    total() {
      return this.storeState.total;
    },
    /**
     * Summary của grid
     */
    summary() {
      return this.storeState.summary;
    },
    /**
     * loading summary
     */
    loadingSummary() {
      return this.storeState.loadingSummary;
    },

    dbOptions() {
      return this.$store.state[ModuleDbOption]?.dbOptions;
    }
  },
  created() {
    const me = this;
    this._gridEvent = {
      loadData: me.loadData,
      changePageSize: me.gridChangePageSize,
      filter: me.reload,
      rowDbClick: me.onRowDbClick,
    };
    this._indexDb = new IndexedDB();
  },
  mounted() {
    const me = this;
    window._listReport = this; // TODO: Trong code không dùng cái này (chỉ dùng để debug)
    //load dữ liệu lần đầu
    this.$nextTick(() => {
      this.reload();
    });

    this.initLayout();

    this.show();

    this.addObserveControl();
  },
  watch: {
    'gridInfo.pageSize'(newVal, oldVal) {
      const me = this;

      if (newVal !== oldVal) {
        //chuyển paging bar về trang đầu
        if (me.grid && typeof me.grid.setPage === 'function') {
          me.grid.setPage(1);
        } else {
          let param = me.lastParam || {
            skip: 0,
            take: me['gridInfo.pageSize'],
          };

          me.loadData(param);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      loadApplyLayout: ModuleLayout + '/loadApply',
    }),

    /**
     * Đẩy dữ liệu lên monitor
     * @param {*} command
     */
    pushTrans(command) {
      const { pushTrans } = collectionMonitor();
      var screenName = '';
      var module = '';
      if (this._report && this.screenCode == '') {
        if (this._report.report_id) {
          this.screenCode = this._report.report_id.replace(
            /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
            ''
          ); // Code không để ký tự đặc biệt
        }
        screenName = this._report.report_name;
        module = this._report.module;
      }
      if (this._report.multipleMonitor) {
        this.multipleMonitorHandler(pushTrans, command, screenName, module ? `${module}.${this.screenCode}` : this.screenCode);
      } else {
        pushTrans(command, screenName, module ? `${module}.${this.screenCode}` : this.screenCode);
      }
    },
    multipleMonitorHandler(pushTrans, command, screenName, screenCode) {

    },
    /**
     * Khởi tạo observe control
     * NCPHUOC 20/04/2022
     * .ms-validate được thêm vào root khi khai báo rules
     */
    addObserveControl() {
      if (!this._observeControls) {
        this._observeControls = [];
        const $el = this.$el;
        const $controls = $el.querySelectorAll('.ms-validate');
        if ($controls && $controls.length > 0) {
          $controls.forEach(item => {
            if (typeof item.getVueInstance === 'function') {
              this._observeControls.push(item.getVueInstance());
            }
          });
        }
      }
    },
    /**
     * Hàm dùng để focus vào ô lỗi đầu tiên
     * dtnga3 (25.08.2022)  - lấy về từ baseDetail
     * */
    focusFirstError() {
      const me = this;
      const $el = me.$el;
      const firstErrorEl = $el.querySelector('.ms-editor .error input,textarea');
      if (firstErrorEl) {
        firstErrorEl.focus();
      }
    },
    beforeOpen(e) {
      const me = this;
      me._popup = me.$vfm.dynamicModals[me.$vfm.dynamicModals.length - 1];
      if (e.ref.params._rawValue) {
        this._formName = e.ref.params._rawValue.name;
        this._report = e.ref.params._rawValue;
        this._formParam = e.ref.params._rawValue;

        // nvtoan2 19/12/2023: Tạo ra 1 cái key để xác định reload báo cáo tại vị trí
        // Cái số nhân kia là số linh tinh thôi, chọn số nào cũng dc
        this._report.KeyReload = Math.floor(Math.random() * 110720) + '';
      }
    },
    beforeClose() {
      delete this._formName;
      delete this._report;
      delete this._formParam;
      this.hide();
      commonFn.closePrintIframe();
    },

    /**
     * Đóng form
     */
    hide() {
      const me = this;
      me._suppendClose = true;
      try {
        me._popup.value = false;
      } catch (e) {
        console.error(e);
      }
      me.$nextTick(() => {
        me._suppendClose = true;
        delete me._popup;
      });
    },

    /**
     * Thay đổi pagesize
     */
    gridChangePageSize(value) {
      this.gridInfo.pageSize = value;
    },

    /**
     * Thực hiện load data
     * HTHIEP 04.05.2022
     */
    async show() {
      //lấy dữ liệu
      const data = await this.loadRecentData(this._formName);

      // Focus vào ô input đầu tiên của form
      this.focusFirstControl();

      //Cập nhật dữ liệu vào model
      this.bindData(data);
    },

    /**
     * focus control nhập liệu đầu tiên
     */
    focusFirstControl() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$ms.commonFn.focusFirstControlInput(this.$el);
        });
      }, 300);
    },

    /**
     * Lấy tham số báo cáo lần gần nhất
     * @param {*} formName
     * @returns
     * NCPHUOC 18/08/2022
     * Modified by NVTUAN1: Lấy thêm tham số chung cho báo cáo không phân biệt mẫu ngang, mẫu dọc, ...
     */
    async loadRecentData(formName) {
      //TODO
      const me = this;
      const refType = me._formParam.ref_type,
        reportId = me._formParam.report_id,
        paramKey = me.getParamKey(),
        reportIdCommon = me.reportIdCommon || this._formName; //Id chung cho báo cáo (mẫu ngang, mẫu dọc, ...)
      let data = {};
      const res = await api.getRecentParam(paramKey, refType, reportId, reportIdCommon);

      const { detailKey } = me._formParam;
      if (res) {

        const { master, format, common } = res;

        if (master) {
          const masterObj = JSON.parse(master);
          Object.assign(data, masterObj);
        }

        if (format) {
          me.assignFormatRecentData(data, format);
        }

        if (common) {
          me.assignCommonRecentData(data, common);
        }

        const details = [];
        if (detailKey) {
          const formData = me._formParam[detailKey];
          if (Array.isArray(formData)) {
            if (Array.isArray(data.detailParams)) {
              formData.forEach(item => {
                const existRow = data.detailParams.find(x => x.ref_detail_id === item.ref_detail_id);
                if (existRow) {
                  //Giữ nguyên năm khấu hao và số tiền nộp thuế
                  const { tax_amount, year_depreciation } = existRow;
                  let extendObj = me.addExtendObjParam(existRow);
                  const row = {
                    ...extendObj,
                    ...item,
                    tax_amount,
                    year_depreciation,
                  };
                  row.amount = (row.total_amount || 0) - (row.tax_amount || 0);
                  details.push(row);
                } else {
                  let extendObj = me.addExtendObjParam(existRow, item);
                  details.push({ ...extendObj, ...item });
                }
              });
            }
          }
        }
        data.detailParams = details;
        delete data[detailKey];
      } else {
        data = { ...me._formParam };
        data.detailParams = [...data[detailKey]];
        delete data[detailKey];
      }

      return data;
    },

    /**
     * Custom dữ liệu lưu chung theo loại chứng từ
     * @param {*} data 
     * @param {*} format 
     */
    assignFormatRecentData(data, format) {
      Object.assign(data, JSON.parse(format));
    },

    /**
     * Custom dữ liệu lưu chung theo báo cáo không phân biệt mẫu ngang, mẫu dọc
     * @param {*} data 
     * @param {*} common 
     * NVTUAN1 24.04.2023
     */
    assignCommonRecentData(data, common) {
      Object.assign(data, JSON.parse(common));
    },

    /**
     * Bổ sung param trong detaiParams vào dữ liệu row
     * @param {*} data
     * @returns
     */
    addExtendObjParam(data, item) {
      return {};
    },

    /**
     * Mặc định lấy theo ref_id
     * Các form override lại nếu cần theo reftype
     * @returns
     */
    getParamKey() {
      return `${this._formParam?.ref_id}`;
    },

    /**
     * Bind dữ liệu cho form
     */
    bindData(data) {
      const me = this;
      Object.assign(me.model, data);
      me.beforeBindData();
    },

    beforeBindData() { },
    /**
     * Hàm xử lý action dbClickRow
     * NNLINH 04.07.2022
     */
    onRowDbClick(row) { },

    initLayout() {
      const me = this;
      if (me.layoutTag) {
        let layout = me.getCacheLayoutTemplate();

        if (!layout || process.env.NODE_ENV === 'development') {
          me.loadApplyLayout(me.layoutTag).then(layout => {
            //set cache
            me.setCacheLayoutTemplate(layout);

            me.applyLayout(layout);
          });
        } else {
          me.applyLayout(layout);
        }
      }
    },

    /**
     * lấy mẫu layout từ cache
     */
    getCacheLayoutTemplate() {
      const me = this;
      try {
        let layoutTemplate;
        let cacheKey = me.getCacheLayoutTemplateKey();
        if (cacheKey) {
          // let cacheData = await me.$ms.indexedDB.get(cacheKey);
          let cacheData = me.$ms.commonFn.getSessionStorage(cacheKey);
          if (cacheData) {
            layoutTemplate = JSON.parse(cacheData);
          }
        }
        return layoutTemplate;
      } catch (ex) {
        console.error(ex);
      }
      return null;
    },
    /**
     * lưu cache mẫu layout
     */
    setCacheLayoutTemplate(layout) {
      const me = this;
      let cacheKey = me.getCacheLayoutTemplateKey();
      if (cacheKey) {
        // let cacheData = await me.$ms.indexedDB.get(cacheKey);
        me.$ms.commonFn.setSessionStorage(cacheKey, JSON.stringify(layout));
      }
    },
    /**
     * lấy cache key mẫu layout
     */
    getCacheLayoutTemplateKey() {
      const me = this;
      let cacheKey = '';
      if (me.Context && me.Context.UserID && me.layoutTag) {
        cacheKey = 'LayoutTemplate_{0}_{1}'.format(me.layoutTag, me.Context.UserID);
      }
      return cacheKey;
    },
    /**
     * Render mẫu
     */
    applyLayout(layout) {
      const me = this;

      me.layout = me.convertToLayoutTemplete(layout);
      let columns = me.getLayoutColumn(layout, me.layoutTag);
      me.grid.initColumns(columns);

      //load dữ liệu lần đầu
      me.$nextTick(() => {
        me.reload();
      });
    },

    convertToLayoutTemplete(layout) {
      let layoutTemplete = {};
      if (layout) {
        layoutTemplete.code = layout.tag;
        layoutTemplete.is_system = layout.is_system;
        layoutTemplete.config = layout.config;
      }
      return Object.assign({}, layoutTemplete);
    },

    /**
     * Lấy thông tin column render từ thông tin của mẫu
     */
    getLayoutColumn(layout, tag) {
      if (layout != undefined) {
        const me = this;
        let columns = JSON.parse(layout.config);

        //nếu là mẫu mặc định và ngôn ngữ khác tiếng việt -> cập nhật caption/title theo ngôn ngữ
        if (layout.is_system) {
          me.localizationColumn(columns, tag);
        }
        //nnlam: orderby lại theo sort_order và lock.
        columns = _(columns)
          .chain()
          .sortBy('sort_order')
          .sortBy(function (column) {
            return !column.lock;
          })
          .value();
        return columns;
      }
    },
    /**
     * Xử lý ngôn ngữ cho caption và title của column
     */
    localizationColumn(columns, tag) {
      const me = this,
        culture = me.Culture;

      //nếu là mẫu mặc định và ngôn ngữ khác tiếng việt -> cập nhật caption/title theo ngôn ngữ
      if (culture !== 'vi') {
        let fn = function (column, field, key) {
          let text = me.$ms.commonFn.getColumnText(field, tag);
          if (typeof text !== 'undefined') {
            column[field] = text;
          }
        };

        for (let i = 0; i < columns.length; i++) {
          let col = columns[i];
          fn(col, 'caption', col.dataField);
          fn(col, 'title', col.dataField + 'Title');
        }
      }
    },

    /**
     * Load lại dữ liệu
     */
    reload() {
      const me = this;
      //chuyển paging bar về trang đầu
      if (me.grid && typeof me.grid.setPage === 'function') {
        me.grid.setPage(1);
      }

      //xóa tham số cũ để reload
      delete me.lastParam;
      me.refresh();
    },
    /**
     * Load lại dữ liệu
     */
    refresh() {
      const me = this;
      let param = me.lastParam || {
        skip: 0,
        take: me.gridInfo.pageSize,
      };

      me.loadData(param);
      //load summary
      if (me.splitLoadRequest) {
        me.loadDataSumary(param);
      }
    },

    /**
     * Load summary cho grid danh sách
     */
    loadDataSumary(payload) {
      const me = this;

      //tham số chỗ này đã qua hàm load data dc xử lý rồi
      let param = {};
      for (let i in payload) {
        switch (i) {
          case 'skip':
          case 'take':
          case 'sort':
          case 'ignoreSummary':
            //bỏ qua
            break;
          // case "columns":
          //   //TODO chỗ này sẽ chế lại chỉ lấy các cột có sum thôi
          //   break;
          default:
            param[i] = payload[i];
            break;
        }
      }
      //fix chỉ đọc summary
      param.type = me.$ms.constant.PagingType.Summary;

      //xử lý cột summary
      if (me.grid && Array.isArray(me.grid.columnx)) {
        var sumColumns = [];
        me.grid.columnx.forEach(col => {
          if (col.summaryType) {
            sumColumns.push([col.dataField, col.summaryType].join(':'));
          }
        });

        if (sumColumns.length > 0) {
          param.sumColumns = sumColumns.join(',');
        }
      }

      /**
       * Gọi request load data
       */
      me.requestLoadDataSummary(param);
    },

    /**
     * Gọi request load summary
     */
    requestLoadDataSummary(payload) {
      const me = this;
      if (me.grid && !me.grid.isGridTree) {
        me.$store.dispatch(`${me.module}/loadSummary`, payload);
      }
    },

    /**
     * Load dữ liệu grid
     */
    loadData(payload) {
      const me = this;
      if (me.grid) {
        //nếu là trang đầu build lại tham số, các trang tiếp theo dùng lastParam và chỉ đổi skip
        if (!payload.skip) {
          //xử lý các tham số khác
          me.processLoadParameter(payload);

          //chuẩn hóa tham số truyền lên server
          me.nomalizeLoadParameter(payload);
        } else {
          for (let i in me.lastParam) {
            switch (i) {
              case 'skip':
                //bỏ qua
                break;
              default:
                payload[i] = me.lastParam[i];
                break;
            }
          }
        }

        //cache lại tham số để dùng cho xuất khẩu và restore data cho lần sau quay lại
        me.lastParam = payload;

        if (me.splitLoadRequest) {
          //fix chỉ đọc data
          payload.type = me.$ms.constant.PagingType.PageData;
        }

        /**
         * Gọi request load data
         */
        me.requestLoadData(payload);
      }
    },

    /**
     * Xử lý điều kiện lọc với nội dung tìm kiếm
     */
    processLoadParameterSearch(payload) {
      const me = this,
        fields = me.searchFields,
        op = me.$ms.constant.FilterOperator.Contains,
        text = (me.searchText || '').trim();

      if (text && Array.isArray(fields) && fields.length > 0) {
        let filter = {
          Field: fields[0],
          Operator: op,
          Value: text,
        };
        payload.filter.push(filter);

        if (fields.length > 1) {
          filter.Ors = [];
          for (let i = 1; i < fields.length; i++) {
            filter.Ors.push({
              Field: fields[i],
              Operator: op,
              Value: text,
            });
          }
        }
      }
    },

    /**
     * Xử lý tham số load dữ liệu
     */
    processLoadParameter(payload) {
      const me = this;

      //filter
      payload.filter = [];
      if (me.grid.filterable && typeof me.grid.getFilterHeader === 'function') {
        payload.filter = me.grid.getFilterHeader();
      }

      //search text
      me.processLoadParameterSearch(payload);

      //column
      payload.columns = me.processLoadParameterColumn(payload);

      //tham số load dữ liệu
      payload.condition = me.getConditionParameter();
      // nếu grid có cấu hình sort default thì
      if (me.grid.defaultSort && Array.isArray(me.grid.defaultSort)) {
        let listSort = [];
        me.grid.defaultSort.forEach(item => {
          // nếu có sort custom thì nếu trùng với item nào thì loại item đó ra khỏi listSort để không bị trùng
          if (payload.Sort) {
            if (!payload.Sort.contains(item.sortField)) {
              listSort.push(`${item.sortField} ${item.sortType == me.$ms.constant.SortStatus.desc ? 'DESC' : 'ASC'}`);
            }
          } else {
            listSort.push(`${item.sortField} ${item.sortType == me.$ms.constant.SortStatus.desc ? 'DESC' : 'ASC'}`);
          }
        });
        let sortDefault = listSort.length > 0 ? listSort.join(', ') : '';
        let sortCustom = payload.Sort ? payload.Sort : '';
        if (sortCustom && sortDefault) {
          payload.sort = [sortCustom, sortDefault].join(', ');
        } else if (!sortCustom && sortDefault) {
          payload.sort = sortDefault;
        } else if (sortCustom && !sortDefault) {
          payload.sort = sortCustom;
        } else {
          payload.sort = '';
        }
      }

      me.customPayload(payload);
    },

    /**
     * Custom tham số payload trước khi call api
     */
    customPayload(payload) { },

    /**
     * Custom tham số load dữ liệu
     */
    processLoadParameterColumn(payload) {
      const me = this;
      let columns = me.grid.columnx;
      let cols = [];
      if (columns) {
        for (let i = 0; i < columns.length; i++) {
          let col = columns[i];
          if (col.dataField && cols.indexOf(col.dataField) === -1) {
            cols.push(col.dataField);
          }
        }
      }
      if (me.grid.idField) {
        cols.push(me.grid.idField);
      }

      if (me.grid.isGridTree) {
        if (me.grid.parentIdField && cols.indexOf(me.grid.parentIdField) === -1) {
          cols.push(me.grid.parentIdField);
        }
      }
      if (me.alwayTakeColumns && me.alwayTakeColumns.length != 0) {
        /*
         * Cấu hình lấy thêm các cột được cấu hình luôn lấy dữ liệu trên grid
         * pvduy 19/01/2021
         */
        for (let i = 0; i < me.alwayTakeColumns.length; i++) {
          if (!cols.includes(me.alwayTakeColumns[i])) {
            cols.push(me.alwayTakeColumns[i]);
          }
        }
      }
      return cols;
    },

    /**
     * Lấy điều kiện load dữ liệu
     */
    getConditionParameter() {
      const me = this;
      let param = {};
      if (me.condition) {
        for (let i in me.condition) {
          let value = me.condition[i];
          if (value) {
            //date
            if (typeof value.getFullYear === 'function') {
              //nếu tên thuộc tính có từ Time -> lấy full datetime
              //else chỉ lấy date
              if (i.indexOf('Time') > -1) {
                value = moment(value).format('YYYY-MM-DD hh:mm:ss');
              } else {
                value = moment(value).format('YYYY-MM-DD');
              }
            }
          }
          param[i] = value;
        }
      }
      return param;
    },

    /**
     * Chuẩn hóa lại tham số truyền lên server
     */
    nomalizeLoadParameter(payload) {
      const me = this;
      if (!payload.skip) {
        delete payload.skip;
      }

      if (payload.filter && payload.filter.length > 0) {
        //Clear múi giờ trước khi đẩy lên server
        payload.filter.forEach((item, i) => {
          let value = item.value;
          if (value) {
            if (typeof value.getFullYear === 'function') {
              item.value = me.$ms.commonFn.getMoment(value).format('YYYY-MM-DDTHH:mm:ss');
            }
          }
        });

        payload.filter = JSON.stringify(payload.filter);
      } else {
        delete payload.filter;
      }

      if (payload.condition && Object.keys(payload.condition).length > 0) {
        payload.condition = JSON.stringify(payload.condition);
      } else {
        delete payload.condition;
      }

      if (payload.columns && payload.columns.length > 0) {
        payload.columns = payload.columns.join(',');
      } else {
        delete payload.columns;
      }
    },

    /**
     * Gọi request load dữ liệu
     * Modiffied NNLINH 04.07.2022: thêm handleBeforeBinding
     */
    async requestLoadData(payload) {
      const me = this;
      if (me.grid && me.grid.isGridTree) {
        me.$store.dispatch(`${me.module}/loadTree`, {
          columns: payload.columns,
        });
      } else {
        let data = await me.$store.dispatch(`${me.module}/load`, payload);
        me.handleBeforeBinding(data);
      }
    },

    /**
     * Hàm validate các control input
     * Hàm này sử dụng component ms-validate
     * để bao ngoài vùng được validate
     * @Chú ý:ref của ms-validate phải là validateObserver
     * dtnga3 (25.08.2022)  - lấy về từ baseDetail
     */
    validateComponents() {
      const me = this;
      let controls = me._observeControls.filter(
        x =>
          x.$el.offsetWidth ||
          x.$el.offsetHeight ||
          x.$el.getClientRects().length ||
          /** Xử lý validate control khi ẩn */
          (x.rules && Array.isArray(x.rules) && x.rules?.some(x => x.hide))
      );
      if (controls.length > 0) {
        const errors = controls.map(x => {
          if (typeof x.validate === 'function') {
            return x.validate();
          }
          return '';
        });
        return !errors.some(x => x);
      }
      return true;
    },
    /**
     * Xử lý dữ liệu trước khi bind Data
     */
    handleBeforeBinding(data) { },

    /**
     * Khai báo custom params
     */
    getCustomReportParams(reportId) {
      return null;
    },


    /**
     * Lấy giá trị tham số áp dụng cho tất cả báo cáo cùng loại theo key common
     * nxhoa 3.11.2023
     */
    getParamReportCommon(reportId) {
      return {
        settingOptions : this.model?.settingOptions
      };
    },

    /**
     * Lấy tham số truyền trực tiếp lên mẫu stimul (trong MISAObjectClass)
     * các mẫu override lại để khai báo tham số riêng
     * @param {*} reportId
     * @returns
     */
    getTemplateParams(reportId) {
      return null;
    },

    /**
     * in chứng từ
     * Modified by NVTUAN1 24.04.2023: Lưu thêm tham số chung cho báo cáo không phân biệt mẫu ngang, dọc, ...
     */
    printVoucher(report) {
      const me = this;
      if (!report || !report.report_id) {
        return;
      }
      let param = {
        ReportId: report.report_id,
        ReportName: report.report_name,
        ReportList: report,
        DataParam: {
          refIds: [me._formParam.ref_id],
          ...me.model,
        },
        ParamKey: me.getParamKey(), // ref_id của chứng từ in
        IsSaveFormat: me.isSaveFormat, //Có lưu tham số in lần trước theo loại chứng từ không
        IsSaveCommon: me.isSaveCommon || true, //Có lưu tham số in lần trước theo báo cáo không
        ReportIdCommon: me.reportIdCommon || this._formName, //Id chung cho báo cáo có 2 loại mẫu ngang, mẫu dọc cần lưu chung tham số in lần trước theo mẫu báo cáo
        //nxhoa 2.11.2023: biến đánh dấu in theo lô để xử lí một số case riêng: ví dụ như load tham số in gần nhất
        IsBatchPrinting: report.is_batch_printing
      };

      const customParams = me.getCustomReportParams(report.report_id);
      if (customParams) {
        param.DataParam = { ...param.DataParam, ...customParams };
      }

      //nxhoa 3.11.2023: Bổ sung hàm lấy tham số áp dụng chung cho tất cả loại báo cáo
      const paramReportCommon = me.getParamReportCommon(report.report_id);
      if (paramReportCommon) {
        param.DataParam.paramReportCommon = paramReportCommon;
      }

      const templateParams = me.getTemplateParams(report.report_id);
      if (templateParams) {
        param.TemplateParam = { ...templateParams };
      }

      report = me.customReport(report);
      me.customPrint(report, param);
    },

    /**
     * Custom print
     * dqdat1 15.12.2022
     */
    customPrint(report, param) {
      const me = this;
      me.print(report, param, true);
    },

    /**
     * Custom thêm param cho report
     * tvhien 22.08.2022
     */
    customReport(report) {
      if (report && report.report_name) {
        report.reportName = report.report_name;
      }
      return report;
    },

    /**
     * Submit các grid đang edit
     * dtnga3 (04.10.2022)
     */
    submitGridEditor() {
      try {
        const me = this,
          { _gridDetails } = me;
        const submitAction = [];
        if (_gridDetails) {
          for (const key in _gridDetails) {
            //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
            if (Object.hasOwnProperty.call(_gridDetails, key)) {
              const keyRef = _gridDetails[key];
              const $gridRef = me.$refs[keyRef];
              if ($gridRef && typeof $gridRef.submitEditor === 'function') {
                submitAction.push($gridRef.submitEditor());
              }
            }
          }
        }

        return Promise.all(submitAction);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Xử lý action trên form
     * @param {*} command
     * NCPHUOC 18/08/2022: Comment lại do đã cache lại tham số trên DB
     */
    async commandClick(command) {
      switch (command) {
        case this.$ms.constant.Command.Ok:
          // Validate các nghiệp vụ khác trước khi in
          if (!this.validateBeforePrintReport()) {
            return;
          }

          /**
           * Lưu lại params vào index db => load lại lần sau
           * nxhoa 3.11.2023: lại mở đoạn code cache vào _indexDb để sử dụng trong trường hợp "Không hiển thị lại lần sau"
           * tuy nhiên form nào cần thì mới lưu
           */
          this.cacheIndexDb();
          this.beforePrintVoucher();
          /**
           * Có một số tùy chọn theo form, 
           * nhưng cần check trước khi show form nên cần lưu vào DB option
           * form nào có cấu hình thì mới lưu
           */
          this.updateDbOption();
          await this.submitGridEditor();
          this.printVoucher(this._report);
          break;
      }
      this.pushTrans(command);
    },

    /**
     * Lưu lại params vào index db => load lại lần sau
     * tuy nhiên form nào cần thì mới lưu
     * nxhoa 6.11.2023
     */
    cacheIndexDb() {
      /**
       * nxhoa 3.11.2023: lại mở đoạn code cache vào _indexDb để sử dụng:
       * ví dụ trong trường hợp "Không hiển thị lại lần sau", 
       * không hiển thị lại lần sau thì có load last param đâu, nên phải lấy trong indexDb
       */
      if (this.isCacheIndexDb) {
        this._indexDb.set(this._formName, this.model);
      }
    },

    /**
     * Lưu một số tùy chọn theo form tham số
     * Sử dụng trong một số trường hợp lưu tùy chọn theo form tham số áp dụng cho nhiều báo cáo
     * @returns
     * nxhoa 6.11.2023
     */
    updateDbOption() {
    },

    /**
    * NVTUAN1 28.10.2022
    * Validate các nghiệp vụ tùy theo từng báo cáo trước khi in báo cáo
    * => DEV override lại hàm này để xử lý validate
    * @returns true or false
    */
    validateBeforePrintReport() {
      return true;
    },

    beforePrintVoucher() {
      const me = this;
      // Thực cập nhật thông tin đã in
      const payload = this._report;
      // Lấy thông tin settingPrintConfig
      commonFn.handleBindSettingReportToPrint(null, this._formParam, me.dbOptions, me._report);

      if (payload.report_type == 1) {
        me.reportSettingApply();
        commonFn.savePrintMultipleReportsConfigPrint(this._report, this._report.printItemInfos ?? this._report.selectedVoucher, this._report);
      }
    },
    reportSettingApply() {
      const me = this;
      // Lấy thông tin tùy chọn in
      const formParam = this._formParam;
      if (this.model) {
        this.model.$ListRefID = formParam?.list_ref_id || formParam?.ref_id;
        this.model.$RefType = formParam?.ref_type;
        this.model.ViewReceiptFullAmount = formParam?.view_receipt_full_amount;
        this.model.PrintInfomationReceiptUnit = formParam?.print_information_receipt_unit;
        this.model.PrintSystemDate = formParam?.print_system_date;
        this.model.PrintVourcherDate = formParam?.print_voucher_date;
        this.model.PrintPreview = formParam?.print_voucher_preview;
        this.model.AllowBatchPrinting = formParam?.allow_batch_printing;
        this.model.DateTimeReport = formParam?.print_system_date ? me.postedDate : null;
        this.model.$PrintedType = formParam?.printed_type || 2;
        this.model.$OrderBy = formParam?.order_by || '';
      }
    },
    /**
     * Xem
     * */
    view(record, formName) {
      const me = this;

      //kiểm tra phân quyền
      me.checkActionPermissionAlert(me.$ms.constant.Permission.View);

      // lấy tên form detail để show
      // dtnga3 (14.07.2022) Nếu bên ngoài có truyền vào tên form detail thì sẽ thực hiện show form đó
      let formDetailName = formName;

      let param = me.getDetailParameter(formDetailName, this.$ms.constant.FormState.View, record);

      me.showDetail(formDetailName, param, {
        submit: function (saveResult, saveParam) {
          if (saveResult.Success) {
            me.afterSaveView(record, saveResult, saveParam);
          }
        },
      });
    },
    /**
     * @private
     * Lấy tham số khi mở form chi tiết
     * */
    getDetailParameter(formName, mode, defaultData) {
      const me = this;

      let param = {
        data: defaultData || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          if (me.$store.state[me.module]._config.field.key) {
            param.id = defaultData[me.$store.state[me.module]._config.field.key];
          }
          break;
      }

      param.mode = mode;

      me.customDetailParam(param);

      return param;
    },
    edit(record, formName) {
      const me = this;

      //kiểm tra phân quyền
      me.checkActionPermissionAlert(me.$ms.constant.Permission.Edit);

      // lấy tên form detail để show
      let formDetailName = formName;

      let param = me.getDetailParameter(formDetailName, this.$ms.constant.FormState.Edit, record);

      me.showDetail(formDetailName, param, {
        submit: function (saveResult, saveParam) {
          if (saveResult.Success) {
            //me.afterSaveEdit(record, saveResult, saveParam);
          }
        },
      });
    },
    customDetailParam(param) { },
    /**
     * Hàm show các popup theo tên lấy đường dẫn từ hàm getPopupomponent
     * @param name tên của component
     * Created by LTDAT(17.06.2020)
     */
    showDetail(name, data, option) {
      const me = this;

      // if (me.isCacheParam) {
      //   me._indexDb = me._indexDb || new IndexedDB();
      //   let key = [name, data.id || ''].filter(x => x).join('_');
      //   let save = Object.assign({}, data, {
      //     module: me.module,
      //     currentPath: location.pathname,
      //   });
      //   me._indexDb.set(key, save);
      // }

      popupUtil.show(name, data, me.getPopupOption(name, option));
    },
    getPopupOption(name, option) {
      const me = this;
      return {
        submit: me.submitDetailCallback,
      };
    },

    /**
     * Link help
     */
    linkHelp(code, type) {
      type = type || 'mimosa';
      return window._helpLink[type] + window._misaHelp[code];
    },
  },
});
